import { ApplicationType } from 'features/Onboarding/types';

type GetApplicationType = (args: {
  isCapitalDeposit?: boolean;
  isShineStart?: boolean;
}) => ApplicationType | undefined;

/**
 * @deprecated use features/Onboarding/lib/getCompanyApplicationType.ts instead
 */
const getApplicationType: GetApplicationType = ({
  isCapitalDeposit,
  isShineStart,
}) => {
  if (isCapitalDeposit === undefined || isShineStart === undefined) {
    // Still loading so return undefined
    return undefined;
  }
  if (isCapitalDeposit) {
    return ApplicationType.CapitalDeposit;
  }
  if (isShineStart) {
    return ApplicationType.ShineStart;
  }
  return ApplicationType.Standard;
};

export default getApplicationType;
